import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Plus, ExternalLink } from 'lucide-react';

const API = 'https://crm.ashbournesystems.ca/api';

export default function Maintenance({ token }) {
  const [plans, setPlans] = useState([]);
  const [clients, setClients] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ client_id: '', monthly_fee: '40', billing_day: '1', start_date: '', next_billing_date: '', notes: '' });
  const headers = { Authorization: `Bearer ${token}` };

  const load = () => {
    axios.get(`${API}/maintenance`, { headers }).then(r => setPlans(r.data)).catch(() => {});
    axios.get(`${API}/clients`, { headers }).then(r => setClients(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/maintenance`, form, { headers });
      toast.success('Maintenance plan created');
      setShowForm(false);
      load();
    } catch (err) { toast.error(err.response?.data?.error || 'Error'); }
  };

  const cancelPlan = async (id) => {
    if (!window.confirm('Cancel this maintenance plan?')) return;
    try {
      await axios.put(`${API}/maintenance/${id}`, { status: 'cancelled', cancel_date: new Date().toISOString().split('T')[0] }, { headers });
      toast.success('Plan cancelled');
      load();
    } catch { toast.error('Error'); }
  };

  const active = plans.filter(p => p.status === 'active');
  const monthlyRecurring = active.reduce((s, p) => s + parseFloat(p.monthly_fee || 0), 0);

  const inputStyle = { width: '100%', padding: '0.65rem', background: '#0e0804', border: '1px solid #2a1a0e', color: '#F5ECD7', fontSize: '0.82rem', outline: 'none', boxSizing: 'border-box', marginBottom: '0.75rem' };
  const labelStyle = { display: 'block', fontSize: '0.62rem', color: '#8a6840', letterSpacing: '0.1em', marginBottom: '4px' };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
        <div>
          <h1 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#F5ECD7', marginBottom: '4px' }}>Maintenance Plans</h1>
          <p style={{ color: '#8a6840', fontSize: '0.85rem' }}>{active.length} active · ${monthlyRecurring.toFixed(0)}/month recurring</p>
        </div>
        <button onClick={() => setShowForm(!showForm)} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: '#B85A22', border: 'none', color: '#F5ECD7', padding: '0.75rem 1.25rem', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 'bold' }}>
          <Plus size={16} /> Add Plan
        </button>
      </div>

      {/* Recurring summary */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1rem', marginBottom: '2rem' }}>
        {[
          { label: 'ACTIVE PLANS', value: active.length },
          { label: 'MONTHLY RECURRING', value: `$${monthlyRecurring.toFixed(0)}` },
          { label: 'ANNUAL RECURRING', value: `$${(monthlyRecurring * 12).toFixed(0)}` },
        ].map(({ label, value }) => (
          <div key={label} style={{ background: '#1a0f08', border: '1px solid #2a1a0e', borderTop: '3px solid #B85A22', padding: '1.25rem' }}>
            <div style={{ fontSize: '0.62rem', color: '#8a6840', letterSpacing: '0.15em', marginBottom: '6px' }}>{label}</div>
            <div style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#F5ECD7' }}>{value}</div>
          </div>
        ))}
      </div>

      {showForm && (
        <div style={{ background: '#1a0f08', border: '1px solid #2a1a0e', borderTop: '3px solid #B85A22', padding: '1.5rem', marginBottom: '2rem' }}>
          <h3 style={{ color: '#F5ECD7', marginBottom: '1.5rem', fontSize: '1rem' }}>New Maintenance Plan</h3>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div><label style={labelStyle}>CLIENT *</label>
                <select style={inputStyle} value={form.client_id} onChange={e => setForm({...form, client_id: e.target.value})} required>
                  <option value="">Select client...</option>
                  {clients.map(c => <option key={c.id} value={c.id}>{c.business_name || c.name}</option>)}
                </select>
              </div>
              <div><label style={labelStyle}>MONTHLY FEE (CAD)</label><input style={inputStyle} type="number" value={form.monthly_fee} onChange={e => setForm({...form, monthly_fee: e.target.value})} /></div>
              <div><label style={labelStyle}>BILLING DAY OF MONTH</label><input style={inputStyle} type="number" min="1" max="28" value={form.billing_day} onChange={e => setForm({...form, billing_day: e.target.value})} /></div>
              <div><label style={labelStyle}>START DATE</label><input style={inputStyle} type="date" value={form.start_date} onChange={e => setForm({...form, start_date: e.target.value})} /></div>
              <div><label style={labelStyle}>NEXT BILLING DATE</label><input style={inputStyle} type="date" value={form.next_billing_date} onChange={e => setForm({...form, next_billing_date: e.target.value})} /></div>
              <div><label style={labelStyle}>NOTES</label><input style={inputStyle} value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} /></div>
            </div>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <button type="submit" style={{ background: '#B85A22', border: 'none', color: '#F5ECD7', padding: '0.75rem 1.5rem', cursor: 'pointer', fontWeight: 'bold' }}>Save Plan</button>
              <button type="button" onClick={() => setShowForm(false)} style={{ background: 'transparent', border: '1px solid #2a1a0e', color: '#8a6840', padding: '0.75rem 1.5rem', cursor: 'pointer' }}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      <div style={{ background: '#1a0f08', border: '1px solid #2a1a0e' }}>
        {plans.length === 0 ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: '#8a6840' }}>No maintenance plans yet</div>
        ) : plans.map((p, i) => (
          <div key={p.id} style={{ padding: '1rem 1.5rem', borderBottom: i < plans.length - 1 ? '1px solid #2a1a0e' : 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
              <div style={{ color: '#F5ECD7', fontWeight: 'bold', fontSize: '0.9rem' }}>{p.business_name || p.client_name}</div>
              <div style={{ color: '#8a6840', fontSize: '0.75rem' }}>{p.client_email}</div>
              {p.live_url && <a href={p.live_url} target="_blank" rel="noreferrer" style={{ color: '#B85A22', fontSize: '0.72rem', display: 'flex', alignItems: 'center', gap: '4px', marginTop: '2px' }}><ExternalLink size={11} />{p.live_url}</a>}
              <div style={{ color: '#8a6840', fontSize: '0.72rem', marginTop: '2px' }}>
                Next billing: {p.next_billing_date ? new Date(p.next_billing_date).toLocaleDateString() : 'N/A'}
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <div style={{ textAlign: 'right' }}>
                <div style={{ color: '#C8941A', fontWeight: 'bold' }}>${p.monthly_fee}/mo</div>
                <span style={{ fontSize: '0.6rem', color: p.status === 'active' ? '#4a9a4a' : '#8b2020' }}>{p.status?.toUpperCase()}</span>
              </div>
              {p.status === 'active' && (
                <button onClick={() => cancelPlan(p.id)} style={{ background: 'transparent', border: '1px solid #8b2020', color: '#8b2020', padding: '0.35rem 0.75rem', cursor: 'pointer', fontSize: '0.7rem' }}>
                  Cancel
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}